
(function(template){
define('vue!app/views/vue/components/cartComponent/addGuestComponent/addGroupMember',['Vue','helpers'],function(Vue,helpers){
    return {
        template: template,
        data: function(){
            return {
                userFirstName : '',
                userLastName : '',
                message: { text:'', class:'' },
                timeOut:null
            }
        },
        methods: {
            hideMessage: function(){
                this.message.text = ''
            },
            handleCancel: function(){
               
                this.$emit('toggle-Show-Add',false)
            },
            handleSubmit: function(){
                var vm = this;
                helpers.addGroupMember(this.userFirstName,this.userLastName).then(function(res){
                    vm.message.text = res.message;
                    vm.message.class = 'success';
                    vm.userFirstName = '';
                    vm.userLastName = '';
                }).fail(function(msg){
                    vm.message.text = msg;
                    vm.message.class = 'error';
                });
            }
        },
        watch: {
            message: {
                handler: function(msg) {
                    var vm = this;
                    if(msg.text.length == 0) {
                        clearTimeout(this.timeOut);
                        return;
                    };
                    this.timeOut = setTimeout(function(){ vm.message.text = '' },3000)
                },
                deep: true
            }
        }
    }
})
})('<div class="segment"> <div class="segment-header">{{localStrings.newGroupMember.title}}</div> <div class="segment-body"> <div v-if="message.text.length>0" role="alert" class="alert" :class="\'alert-\'+message.class"> <button type="button" class="close" @click="hideMessage">&times;</button> {{message.text}} </div> <input :placeholder="localStrings.newGroupMember.firstNamePlaceHolder" type="text" v-model="userFirstName" /> <input :placeholder="localStrings.newGroupMember.lastNamePlaceHolder" type="text" v-model="userLastName" /> <div class="segment-body-controls"> <button class="btn cart-login-btn" v-on:click="handleSubmit">{{localStrings.newGroupMember.submitButtonText}}</button> <button class="btn cart-login-btn" v-on:click="handleCancel">{{localStrings.newGroupMember.cancelButtonText}}</button> </div> </div> </div>');
